import {React, useState, useEffect }from 'react';

function HowToDrawContent(props) {
  const [faker, setFaker] = useState(false);
  
  useEffect(() => {
    setFaker(props.player.faker);
  }, [props.player.faker]);
  
    return (
      <div>
        {faker ?
          <p>You are the imposter artist. Try to blend in and contribute to the subject drawing!</p> :
          <p>It is now your turn to draw. Illustrate the drawing subject written above, but don't add too much detail and give away the subject to the impostor artist!</p>
        }
        <p>You only have {props.gameConfig.time} seconds or {props.gameConfig.strokes} strokes for your drawing - whichever comes frist.</p>
      </div>
    );
}

export default HowToDrawContent;
